import React from 'react';
import { NewCustomViewForm } from '../create/NewCustomViewForm';
import { MenuItemList } from '../list/MenuItemList';
import { UpdateCustomViewForm } from '../update/UpdateCustomViewForm';
import { useCustomViewsContext } from '../context/CustomViewsContext';

export const DropdownBody: React.FC = () => {
  const { customViewsState } = useCustomViewsContext();
  if (!customViewsState.isEdit) {
    return <MenuItemList />;
  }
  if (customViewsState.isCreate) {
    return <NewCustomViewForm />;
  }

  if (customViewsState.updatingView) {
    return <UpdateCustomViewForm customView={customViewsState.updatingView} />;
  }

  return <MenuItemList isEdit />;
};
